import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface Cancelled1pDeliveryOrdersProps extends BaseTemplateProps {
  description: string
  orderId: string
}

export const Cancelled1pDeliveryOrders: TemplateDefinition<Cancelled1pDeliveryOrdersProps> = {
  renderParams: (props: Cancelled1pDeliveryOrdersProps) => ({
    messageKey: 'notificationsDomain.templates.cancelled1pDeliveryOrders',
    values: {
      orderId: props.orderId,
      description: props.description,
    },
  }),
}
